module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-c1620dac9e84c79b91bf0e56938a54d3.svg";